(function () {
  const EXPERIMENT_KEY = "recommendations_order_ab_test_v1";
  const EXPERIMENT_NAME = "recommendations_order_product_page";

  const main = document.querySelector("main");

  if (!main) return;

  const sections = {
    related: main.querySelector('[id*="__product-recommendations"]'),
    recentlyViewed: main.querySelector('[id*="__recently-viewed"]'),
    smartRecommendations: main.querySelector('[id*="__smart_recommendations"]')
  };

  if (
    !sections.related ||
    !sections.recentlyViewed ||
    !sections.smartRecommendations
  ) {
    console.warn("A/B recommendations test: one or more sections were not found.", sections);
    document.documentElement.dataset.recommendationsAbReady = "true";
    return;
  }

  let variant = localStorage.getItem(EXPERIMENT_KEY);

  if (!variant) {
    variant = Math.random() < 0.5 ? "A" : "B";
    localStorage.setItem(EXPERIMENT_KEY, variant);
  }

  const orderByVariant = {
    A: [
      sections.related,
      sections.smartRecommendations,
      sections.recentlyViewed
    ],
    B: [
      sections.smartRecommendations,
      sections.related,
      sections.recentlyViewed
    ]
  };

  orderByVariant[variant].forEach((section) => {
    main.appendChild(section);
  });

  document.documentElement.dataset.recommendationsAbVariant = variant;
  document.documentElement.dataset.recommendationsAbReady = "true";

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "recommendations_ab_test_assigned",
    experiment_name: EXPERIMENT_NAME,
    experiment_variant: variant
  });
})();

(function () {
  const EXPERIMENT_KEY = "recommendations_order_ab_test_v1";
  const EXPERIMENT_NAME = "recommendations_order_product_page";

  const variant = localStorage.getItem(EXPERIMENT_KEY);

  if (!variant) return;

  const main = document.querySelector("main");

  if (!main) return;

  const recommendationSections = [
    {
      key: "related",
      element: main.querySelector('[id*="__product-recommendations"]')
    },
    {
      key: "recently_viewed",
      element: main.querySelector('[id*="__recently-viewed"]')
    },
    {
      key: "smart_recommendations",
      element: main.querySelector('[id*="__smart_recommendations"]')
    }
  ];

  recommendationSections.forEach(({ key, element }) => {
    if (!element) return;

    element.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.addEventListener("click", function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "recommendation_product_click",
          experiment_name: EXPERIMENT_NAME,
          experiment_variant: variant,
          recommendation_section: key,
          destination_url: link.href
        });

        sessionStorage.setItem("last_recommendation_click", JSON.stringify({
          experiment_name: EXPERIMENT_NAME,
          experiment_variant: variant,
          recommendation_section: key,
          destination_url: link.href,
          clicked_at: Date.now()
        }));
      });
    });
  });
})();

(function () {
  const EXPERIMENT_KEY = "recommendations_order_ab_test_v1";
  const EXPERIMENT_NAME = "recommendations_order_product_page";

  const variant = localStorage.getItem(EXPERIMENT_KEY);

  if (!variant || !("IntersectionObserver" in window)) return;

  const main = document.querySelector("main");

  if (!main) return;

  const recommendationSections = [
    {
      key: "related",
      element: main.querySelector('[id*="__product-recommendations"]')
    },
    {
      key: "recently_viewed",
      element: main.querySelector('[id*="__recently-viewed"]')
    },
    {
      key: "smart_recommendations",
      element: main.querySelector('[id*="__smart_recommendations"]')
    }
  ];

  const viewedSections = new Set();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const sectionData = recommendationSections.find(
        (item) => item.element === entry.target
      );

      if (!sectionData || viewedSections.has(sectionData.key)) return;

      viewedSections.add(sectionData.key);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "recommendation_section_view",
        experiment_name: EXPERIMENT_NAME,
        experiment_variant: variant,
        recommendation_section: sectionData.key
      });
    });
  }, {
    threshold: 0.5
  });

  recommendationSections.forEach(({ element }) => {
    if (element) observer.observe(element);
  });
})();